import { ICaseType } from '~/types/case/models'

export async function getStartingCaseTypeListData(): Promise<ICaseType[]> {
  return [
    {
      id: 'XXCAT0001',
      hrid: 'CAT0001',
      canBeDeleted: true,
      descr: 'Service Down',
    },
    // No 'Address Change' (XXCAT0002, removed 2026-10-12): an address change is
    // a Service Request, not a case -- see api/msw/api/serviceRequestTypes. The
    // id is retired rather than reused, so a browser's persisted mock data
    // cannot pair it with a different label.
    {
      // Matches staging's and production's case types (2026-10-12): Service
      // Down and this.
      id: 'XXCAT0003',
      hrid: 'CAT0003',
      canBeDeleted: true,
      descr: 'Service Intermittent',
    },
  ]
}
